
export function customDateConversion(d:Date|string) {
    if (d != null) {
        if (typeof(d) === 'object') {
            const month = ('0' + (d.getMonth() + 1)).slice(-2)
            const day = ('0' + (d.getDate())).slice(-2)

            const customDate = `${d.getFullYear()}-${month}-${day}`;

            return customDate;
        } else {
            return d.split('T')[0];
        }
    }
}
